export default __webpack_public_path__ + "static/media/guesty_lite_step7.7a27fe7f.png";